import { MimaText } from '../../../components';
import {
	NewBeneficiaryContainer,
	SavedBeneficiaryContainer,
} from '../../../containers';
import styles from '../../../assets/styles/Wallet/TransferFunds.module.scss';
import BeneficiaryList from './BeneficiaryList';
import { userStore } from '../../../stores';
import React from 'react';
import BankList from './BankList';

const TransferFundOptions = ({
	transferSwitchState,
	goToSaved,
	beneficiaryList,
	onSelectBeneficiary,
	beneficiaryContent,
	goToBankList,
	bankListContent,
	onSelectBank,
	goToNew,
	savedActive,
	newActive,
	newBeneficiarySelectedState,
	savedBeneficiarySelectedState,
	beneficiaries,
	banks,
	stage2,
	setStage2,
	setShowSurvey,
}) => {
	return (
		<div>
			{bankListContent ? (
				<BankList onSelectBank={onSelectBank} banks={banks} />
			) : beneficiaryContent ? (
				<BeneficiaryList
					onSelectBeneficiary={onSelectBeneficiary}
					beneficiaries={beneficiaries}
				/>
			) : (
				<>
					<MimaText variant="subtitle" mb={1.5} align="center">
						Make A Payment
					</MimaText>
					<MimaText variant="small" mb={3} align="center">
						{!userStore.user.hasPin
							? 'Kindly set your Pin on the settings page to use this feature'
							: ''}
					</MimaText>
					<div className={styles.beneficiary}>
						<div
							className={`${
								savedActive
									? styles.beneficiary__saved
									: styles.beneficiary__saved_b
							}`}
							onClick={goToSaved}>
							Saved Beneficiary
						</div>
						<div
							className={`${
								!newActive ? styles.beneficiary__new : styles.beneficiary__new_b
							}`}
							onClick={goToNew}>
							New Beneficiary
						</div>
					</div>
					{savedActive && (
						<SavedBeneficiaryContainer
							beneficiaryList={beneficiaryList}
							transferSwitchState={transferSwitchState}
							selectedState={savedBeneficiarySelectedState}
							setShowSurvey={setShowSurvey}
						/>
					)}
					{newActive && (
						<NewBeneficiaryContainer
							transferSwitchState={transferSwitchState}
							goToBankList={goToBankList}
							selectedState={newBeneficiarySelectedState}
							stage2={stage2}
							setStage2={setStage2}
						/>
					)}
				</>
			)}
		</div>
	);
};

export default TransferFundOptions;
